export default {
  data() {
    return {
      isMinusBtnActive: false,
      isPlusBtnActive: true,
      itemCount: 1
    }
  },
  methods: {
    countUp() {
      const itemCount = parseInt(this.itemCount)
      this.itemCount = itemCount + 1
      this.isMinusBtnActive = true
    },
    countDown() {
      const itemCount = parseInt(this.itemCount)
      this.itemCount = itemCount - 1
      if (this.itemCount <= 1) {
        this.isMinusBtnActive = false
        this.itemCount = 1
      }
    }
  }
}
